import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=30eb7610&scoped=true&"
import script from "./skeleton.vue?vue&type=script&lang=js&"
export * from "./skeleton.vue?vue&type=script&lang=js&"
import style0 from "./skeleton.vue?vue&type=style&index=0&id=30eb7610&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eb7610",
  null
  
)

export default component.exports